import React, { useState } from "react";
import { Calculator } from "lucide-react";

const RULE = { gold: 100, btc: 500 };

export function LotCalculator({ t }) {
  const [bal, setBal] = useState("500");
  const [ins, setIns] = useState("gold");
  const b = Math.max(0, Number(bal) || 0);
  const lot = Math.floor(b / RULE[ins]) * 0.01;
  const layer = Math.floor((lot / 2) * 100 + 1e-9) / 100;
  return (
    <div className="surface p-5 sm:p-6 border-gold/40" data-testid="lot-calculator">
      <div className="flex items-center gap-2 mb-4"><Calculator size={18} className="text-gold" /><h3 className="font-head text-lg text-white">{t.calcH}</h3></div>
      <label className="text-xs text-slate-500 uppercase tracking-wider">{t.calcBal}</label>
      <input data-testid="calc-balance" type="number" inputMode="decimal" min="0" value={bal} onChange={(e) => setBal(e.target.value)}
        className="w-full mt-1.5 mb-3 bg-[#0A0A0B] border border-[color:var(--border-strong)] px-4 py-3 text-lg font-mono text-white focus:border-gold focus:outline-none" />
      <div className="grid grid-cols-2 gap-2 mb-5">
        {[["gold", t.calcGold], ["btc", t.calcBtc]].map(([k, l]) => (
          <button key={k} data-testid={`calc-${k}`} onClick={() => setIns(k)}
            className={`py-2.5 text-sm border transition-colors duration-200 ${ins === k ? "bg-gold text-black border-gold font-semibold" : "border-[color:var(--border-strong)] text-slate-300"}`}>{l}</button>
        ))}
      </div>
      {lot < 0.01 ? (
        <div data-testid="calc-low" className="text-sm text-amber-400">{t.calcLow}</div>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          <div><div data-testid="calc-max-lot" className="font-mono text-3xl text-gold">{lot.toFixed(2)}</div><div className="text-[11px] text-slate-500 uppercase mt-1">{t.calcMax}</div></div>
          {layer >= 0.01 && <div><div data-testid="calc-layer-lot" className="font-mono text-3xl text-white">{layer.toFixed(2)}</div><div className="text-[11px] text-slate-500 uppercase mt-1">{t.calcLayer}</div></div>}
        </div>
      )}
      <div className="text-[11px] text-slate-500 mt-4">{t.calcRule}</div>
    </div>
  );
}
